import React from "react";
import {Container, Row, Col, Image, Button} from "react-bootstrap";
import DotsImage from "../assets/img/dots-5.svg";
import FirewallImage from "../assets/img/wholesale_voice_1.png";
import FlashCallFirewallImage from "../assets/img/group-427318290.png";
import NetworkProbeImage from "../assets/img/group-427318292.png";
import { useNavigate } from "react-router-dom";
import MNPImage from "../assets/img/group-81.png";

const SectionFour = () => {
  const navigate = useNavigate();
  return (
    <section className="sf-section-four">
      <Container>
        <Row className="sf-overlap">
          <Col xs={12} md={4} className="mb-4">
            <div className="sf-frame">
              <Image className="sf-img" src={FirewallImage} fluid />
              <div className="sf-text-wrapper">Wholesale Voice</div>
              <p className="sf-p">
                Digi-Touch delivers globally competitive wholesale voice termination,
                helping partners connect to international destinations at optimized rates.
                Through an extensive network of trusted carrier routes, we enable scalable
                voice traffic, cost efficiency, and consistent quality, supporting growth
                in both established and emerging markets.
              </p>
            {/*  <div className="sf-cta">*/}
            {/*    <Button*/}
            {/*        onClick={() => navigate("/contact")}*/}
            {/*        className="navbar-contact-us-btn btn d-inline-block btn-primary"*/}
            {/*    >*/}
            {/*      Contact Us*/}
            {/*    </Button>*/}
            {/*</div>*/}

            </div>
          </Col>
          <Col xs={12} md={4} className="mb-4">
            <div className="sf-frame">
              <Image className="sf-img" src={FlashCallFirewallImage} fluid />
              <div className="sf-text-wrapper">Text to Speech</div>
              <p className="sf-p">
                Our Text to Speech solution enables businesses and service providers to
                convert text messages into natural-sounding voice calls for alerts, notifications,
                reminders, and customer communications. Designed for scalability and reliability,
                TTS allows partners to deliver automated voice messaging efficiently while
                maintaining consistent call quality, full traffic visibility, and control
                over delivery and routing.
              </p>
              {/*<div className="sf-cta">*/}
              {/*  <Button*/}
              {/*      onClick={() => navigate("/contact")}*/}
              {/*      className="navbar-contact-us-btn btn d-inline-block btn-primary"*/}
              {/*  >*/}
              {/*    Contact Us*/}
              {/*  </Button>*/}
              {/*</div>*/}
            </div>
          </Col>
          <Col xs={12} md={4} className="mb-4">
            <div className="sf-frame-2">
              <Image className="sf-group-2" src={NetworkProbeImage} fluid />
              <div className="sf-text-wrapper">Voice Firewall</div>
              <p className="sf-p">
                Our Voice Firewall solution provides operators with complete visibility and
                control over A2P voice traffic, enabling them to detect, manage, and monetize
                enterprise-originated calls. By accurately identifying A2P voice usage,
                operators can protect networks from bypass, establish clear monetization models,
                and secure revenues across both A2P Voice and A2P SMS without impacting
                legitimate traffic or customer experience.
              </p>
              {/*<div className="sf-cta">*/}
              {/*  <Button*/}
              {/*      onClick={() => navigate("/contact")}*/}
              {/*      className="navbar-contact-us-btn btn d-inline-block btn-primary"*/}
              {/*  >*/}
              {/*    Contact Us*/}
              {/*  </Button>*/}
              {/*</div>*/}
            </div>
          </Col>
          {/*<Col xs={12} md={6} className="mb-4">*/}
          {/*  <div className="sf-frame-2">*/}
          {/*    <Image className="sf-group-2" src={MNPImage} fluid />*/}
          {/*    <div className="sf-text-wrapper">Mobile Number Portability</div>*/}
          {/*    <p className="sf-p">*/}
          {/*      With our MNP service, enterprises can ensure a 100% SMS delivery*/}
          {/*      rate, eliminate message failures, and provide an exceptional*/}
          {/*      customer experience.*/}
          {/*    </p>*/}
          {/*  </div>*/}
          {/*</Col>*/}
        </Row>
      </Container>
      {/*<div className="sf-dots-image-container">*/}
      {/*  <div id="products" className="dot-background">*/}

      {/*  </div>*/}
      {/*</div>*/}
    </section>
  );
};

export default SectionFour;
